import React from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Constants and Variables
const date = new Date();
const year = date.getFullYear();

function Footer() {
  return (
    <div className="Footer">
      <nav className="navbar bottom navbar-light bg-light">
        <a className="navbar-brand" href="...">
          Copright NAHC {year}
        </a>
      </nav>
    </div>
  );
}

export default Footer;
